import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from '../services/user.service';
import { SessionService } from '../services/session.service';
import {CommonDataService} from "../services/common-data.service";
import {ConfirmationService, Message} from "primeng/primeng";
import {AddEditOrdersComponent} from "../../orders/add-edit-orders/add-edit-orders.component";
import {Observable} from "rxjs/Observable";
import {Observer} from "rxjs/Observer";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

    isToggled: boolean = false;
    msgs: Message[] = [];

    @Output() toggled = new EventEmitter<boolean>();
    constructor(private userService: UserService, private sessionService: SessionService, private router: Router,
                private commonDataService: CommonDataService,
                private confirmationService: ConfirmationService
    ) {}

    ngOnInit() {}

    menuToggle() {
        this.isToggled = !this.isToggled;
        this.toggled.emit(this.isToggled);
    }

    submitChanges() {
        this.commonDataService.refreshView()
            .subscribe(
                data => {
                    this.msgs.push({ severity: 'success', detail: 'Changes are submitted successfully!' });
                    setTimeout(()=>{
                        this.msgs = [];
                    }, 3000);
                },
                error => {
                    console.log(error);
                    this.msgs.push({ severity: 'error', detail: error.message });
                    setTimeout(()=>{
                        this.msgs = [];
                    }, 3000);
                }
            );
    }

    confirm(observer) {
        this.confirmationService.confirm({
            message: 'You haven’t saved this order yet. Do you want to leave without saving?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.commonDataService.setUnsavedChanges(false);
                observer.next(true);
                observer.complete();
                this.executeLogOut();
            },
            reject: () => {
                observer.next(false);
                observer.complete();
            }
        });
    }

    logOut() {
        if (this.commonDataService.unsavedChanges) {
            let obs = Observable.create((observer: Observer<boolean>) => {
                this.confirm(observer);
            });
            obs.subscribe();
        } else {
            this.executeLogOut();
        }
    }

    executeLogOut() {
        this.userService.userLogout()
            .subscribe(
                data => {
                    this.sessionService.destroySessionCookie(true);
                    //clearAllSorting();
                    this.router.navigate(['/']);
                },
                error => {
                    this.sessionService.destroySessionCookie(true);
                    this.router.navigate(['/']);
                }
            );
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/header/header.component.ts